import request from "@/utils/request";

export default function agentAddMaintenanceMan(params) {
    return request.post(
        `/user/maintenanceMan/agentAddMaintenanceMan`, undefined, {
            params
        }
    )
}
